import apiClient from "../helpers/apiClient";

export interface ITicket {
    waiting_list?:number,// user de la waiting list
    note:string,
    status?:string,
}

export async function getTickets(params:any) {
    const response = await apiClient.get(`/waitinglist/admin/tickets/`,{params: params});
    return response.data;
}

export async function getTicket(ticket_id:number) {
    const response = await apiClient.get(`/waitinglist/admin/tickets/${ticket_id}/`);
    return response.data;
}

export async function createTicket(ticket:ITicket) {
    const response = await apiClient.post(`/waitinglist/admin/tickets/`,{...ticket});
    return response;
}

export async function updateTicket(idTicket:number,ticket:ITicket) {
    const response = await apiClient.patch(`/waitinglist/admin/tickets/${idTicket}/`,{...ticket});
    return response;
}